var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuggestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.1
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.90039C20.1602 2.90039 21.0996 3.83977 21.0996 5V17C21.0996 18.1602 20.1602 19.0996 19 19.0996H7.04102L4.57031 21.5703L4.53809 21.6035L4.27734 21.8633L3.9248 22.2168C3.54696 22.5946 2.90039 22.3273 2.90039 21.793V5C2.90039 3.83977 3.83977 2.90039 5 2.90039H19ZM5 4.59961C4.77923 4.59961 4.59961 4.77923 4.59961 5V19.1377L5.86914 17.8682L6.30859 17.4297L6.33789 17.4004H19C19.2208 17.4004 19.4004 17.2208 19.4004 17V5C19.4004 4.77923 19.2208 4.59961 19 4.59961H5ZM12 13.1504C12.7452 13.1504 13.3496 13.7548 13.3496 14.5C13.3496 15.2452 12.7452 15.8496 12 15.8496C11.2548 15.8496 10.6504 15.2452 10.6504 14.5C10.6504 13.7548 11.2548 13.1504 12 13.1504ZM12 5.90039C12.6072 5.90039 13.0996 6.39277 13.0996 7V11C13.0996 11.6072 12.6072 12.0996 12 12.0996C11.3928 12.0996 10.9004 11.6072 10.9004 11V7C10.9004 6.39277 11.3928 5.90039 12 5.90039Z",
    fill: "currentFill",
    stroke: "currentFill",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuggestion);
export default __webpack_public_path__ + "static/media/icon-suggestion.8dd98e320569924ab08887f4d6d8a5ff.svg";
export { ForwardRef as ReactComponent };